import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getPythProHistory, GetPythProHistoryParams } from './getHistory';

export const usePythProHistory = (params: GetPythProHistoryParams) => {
  const reactQueryOptions = useMemo(() => {
    return queryOptions({
      queryKey: getKey(params),
      queryFn: getFn(params),
    });
  }, [params]);

  return useQuery(reactQueryOptions);
};

const getKey = (params: GetPythProHistoryParams) => {
  return ['pyth-pro/history', params];
};
const getFn = (params: GetPythProHistoryParams) => () =>
  getPythProHistory(params);
usePythProHistory.getQueryKey = getKey;
usePythProHistory.getQueryFn = getFn;
